import {all, call, fork, put, takeEvery} from 'redux-saga/effects'
import {
  TagsActionTypes, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError
} from '@actions/tag'
import tagApi from '@api/tag'
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(tagApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(tagApi.delete, payload);
    yield put(deleteSuccess(payload));
  } catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(tagApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data));
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(tagApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data))
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* tagsSaga() {
  yield all([
    yield takeEvery(TagsActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(TagsActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(TagsActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(TagsActionTypes.UPDATE_REQUEST, handleUpdate),
  ])
}

export default tagsSaga
